module.exports = __webpack_public_path__ + "static/media/specific-risk-red-dna.a27056f4.svg";